module.exports = __webpack_public_path__ + "static/media/2_B.096d4a3e.jpg";